import { Icon, IconsEnum } from 'components/Icons';
import { Stato, stateDictionary } from 'features/ippica/types';
import { capitalize, isNotEmpty } from 'utility/functions';
import { useEffect, useState } from 'react';

import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import { IppicaNazioneImageDto } from 'types/swagger';
import styles from './IppicaNavAntepostRow.module.scss';
import { useIsDarkTheme } from 'hooks/useIsDarkTheme';
import { useRouter } from 'next/router';

export type IppicaNavAntepostRowProps = {
  titolo: string;
  ippodromo?: string;
  siglaRiunione?: string;
  data: string;
  codiceProgramma: number;
  numeroAvvenimento: number;
  tipoIppica?: number;
  image?: IppicaNazioneImageDto; // ImageProps & { srcFallback: string };
  codiceStatoAvvenimento?: number;
};

export const IppicaNavAntepostRow = ({
  data,
  image,
  titolo,
  ippodromo,
  codiceProgramma,
  numeroAvvenimento,
  codiceStatoAvvenimento,
  siglaRiunione,
}: IppicaNavAntepostRowProps) => {
  const date = new Date(data);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');

  const { isDarkMode } = useIsDarkTheme();

  const router = useRouter();

  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    setIsActive(router.query.details === `${codiceProgramma + '-' + numeroAvvenimento}`);
  }, [codiceProgramma, numeroAvvenimento, router]);

  const renderImage = () => {
    const { alt, title, srcFallback } = image ?? {};

    let country = '';

    if (typeof siglaRiunione === 'string') {
      country = siglaRiunione?.substring(0, 2);
    }

    let imgSrc = srcFallback;

    if (country) {
      imgSrc = `https://cdn.snai.it/promozioni/manifestazioni/ippica/${country}.svg`;
    }

    if (isNotEmpty(imgSrc)) {
      return (
        <div className={styles.imageContainer}>
          <DynamicImage
            src={`${imgSrc}`}
            alt={alt ?? ''}
            title={title}
            fill
            loading={enLoading.lazy}
            decoding="async"
            className={styles.imageCountry}
          />
        </div>
      );
    }

    return <span className={styles.emptyImg}></span>;
  };

  return (
    <AnchorLink
      href={'/ippica/' + codiceProgramma + '-' + numeroAvvenimento}
      className={`${styles.container} ${isActive ? styles.active : ''}`}
      target="_self"
    >
      {stateDictionary[`${codiceStatoAvvenimento}`] === Stato.Annullata && (
        <Icon
          iconId={IconsEnum[`LEGENDA_ANNULLATA_${isDarkMode ? 'DARK' : 'LIGHT'}` as keyof typeof IconsEnum]}
          className={styles.annullataIcon}
        />
      )}

      {renderImage()}

      <div className={styles.firstCol}>
        <p className={styles.title} suppressHydrationWarning>
          {capitalize(titolo!)}
        </p>
        <p className={styles.subtitle}>{ippodromo}</p>
      </div>
      <div className={styles.secondCol}>
        <p className={styles.text} suppressHydrationWarning>
          {day}/{month}
        </p>
        <p className={styles.text} suppressHydrationWarning>
          {hours}:{minutes}
        </p>
      </div>
    </AnchorLink>
  );
};
